import type {AppLanguage} from 'platform/locale';

const capitalizeFirstCharacter = (value: string, locale: AppLanguage) => {
  const [firstCharacter, ...remainingCharacters] = [...value];

  return `${firstCharacter?.toLocaleUpperCase(locale) ?? ''}${remainingCharacters.join('')}`;
};

export const formatWeekday = (date: Date, locale: AppLanguage) =>
  capitalizeFirstCharacter(
    // eslint-disable-next-line eag/no-external-date-time-format-functions -- platform/locale has no weekday format
    new Intl.DateTimeFormat(locale, {weekday: 'long'}).format(date),
    locale
  );
